import { useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import cover from "../../assets/media/Player.png";
import { blogs } from "../../constants/mediaList";
import "./style.css";
import { useEffect } from "react";

const MediaPage = () => {
  const articles = blogs;
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(tab || "All");

  const ref = useRef()
  const tabs = [
    {
      id: 1,
      name: "All",
    },
    {
      id: 1,
      name: "News",
    },
    {
      id: 1,
      name: "Videos",
    },
  ];

  const rightSideData = articles?.find((item) => (item.id = 1));

  const contents = [
    // {
    //   id: 1,
    //   text: "Welcome",
    //   date: "July 09, 2025",
    //   duration: "23sec",
    //   images: [
    //     {
    //       src: "https://helmsman-static-bucket-development.s3.us-west-1.amazonaws.com/Video/Regulate_Expo_Tutorial_Draft_A.mp4",
    //       text: "",
    //       isVideo: true,
    //     },
    //   ],
    // },
    {
      id: 7,
      text: "Product Demonstration",
      date: "July 09, 2025",
      duration: "2min",

      images: [
        {
          src: "https://helmsman-static-bucket-development.s3.us-west-1.amazonaws.com/Video/Regulate Product Demonstration.mp4",
          text: "",
          isArray: true,
          isVideo: true,
          isLoomVideo: true,
        },
      ],
    },
    {
      id: 2,
      text: "Ingredients",
      date: "July 09, 2025",
      duration: "1min",

      images: [
        {
          src: "https://helmsman-static-bucket-development.s3.us-west-1.amazonaws.com/Video/TUT_Ingredients.mp4",
          text: "",
          isVideo: true,
        },
      ],
    },
    {
      id: 3,
      text: "Recipes",
      date: "July 09, 2025",
      duration: "2min",

      images: [
        {
          src: "https://helmsman-static-bucket-development.s3.us-west-1.amazonaws.com/Video/TUT_Recipe.mp4",
          text: "",
          isVideo: true,
        },
      ],
    },
    {
      id: 4,
      text: "Account Verification",
      date: "July 09, 2025",
      duration: "33sec",

      images: [
        {
          src: "https://helmsman-static-bucket-development.s3.us-west-1.amazonaws.com/Video/TUT_ContactVerification.mp4",
          text: "",
          isVideo: true,
        },
      ],
    },

    {
      id: 5,
      text: "Register With Regulate",
      date: "July 09, 2025",
      duration: "50sec",

      images: [
        {
          src: "https://helmsman-static-bucket-development.s3.us-west-1.amazonaws.com/Video/Regulate_SignIn_Video_A.mp4",
          text: "",
          isVideo: true,
        },
      ],
    },
  ];

  useEffect(() => {
    if (tab && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [tab]);

  return (
    <div className="media-container d-flex flex-column align-items-center justify-content-center w-100">
      <div className="media-header-container d-flex w-100">
        <div className="section-container page-container">
          <div className="w-100">
            <div className="title">
              News, videos, reports, and <br />
              event recaps that keep CPG teams <br />
              <span className="new-line">
                ahead on compliance and consumer trends.
              </span>
            </div>

            <div className="info-text">
              <div>
                In a $4 trillion industry still running on spreadsheets, staying
                ahead means reading deeper and moving smarter.
              </div>
              <a
                href="https://meetings.hubspot.com/carly-weitz/insight-suite?uuid=7d3b3785-0a66-47b0-b943-2f695b8a7120"
                target="_blank"
                rel="noreferrer"
              >
                <b> Start here.</b>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="news-container d-flex justify-content-center w-100">
        <div className="section-container page-container w-100">
          <div className="tab-container d-flex">
            {tabs.map((tab) => (
              <div
                className={`d-flex tab-name ${activeTab == tab?.name ? "active-tab" : ""
                  }`}
                onClick={() => {
                  setActiveTab(tab.name);
                }}
              >
                {tab?.name}
              </div>
            ))}
          </div>
          <div
            className="post-container"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "3.75rem",
            }}
          >
            {activeTab == "News" || activeTab == "All" ? (
              <div>
                <div className="Caption off-black" style={{ fontSize: "20px", marginBottom: "20px" }}>Latest Posts</div>
                <div className="d-flex blog-container">
                  <div className="big-post">
                    <div
                      className="big-card"
                      style={{
                        position: "relative",
                        width: "fit-content",
                        cursor: "pointer",
                        borderRadius: "0.5rem",
                      }}
                      onClick={() => window.open(rightSideData?.link)}
                    >
                      <div
                        style={{ position: "relative", borderRadius: "0.5rem" }}
                      >
                        <img
                          src={rightSideData?.image}
                          alt=""
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            display: "block",
                            borderRadius: "0.5rem",
                          }}
                        />

                        <div
                          style={{
                            position: "absolute",
                            top: "1px",
                            left: 0,
                            height: "100%",
                            width: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.4)",
                            borderRadius: "0.5rem",
                          }}
                        ></div>

                        <div
                          style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            width: "100%",
                            padding: "1rem",
                            color: "white",
                            zIndex: 2,
                            background:
                              "linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent)",
                            borderRadius: "0.5rem",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "0.875rem",
                              marginBottom: "0.25rem",
                            }}
                            className="d-flex align-items-center"
                          >
                            <span className="ate">{rightSideData?.Date}</span>
                            <span className="white-dot"></span>
                            <span className="author">
                              {rightSideData?.author}
                            </span>
                          </div>
                          <div className="big-card-title">
                            {rightSideData?.title}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="small-posts-container">
                    {articles
                      ?.filter((item) => item.id != 1)
                      ?.slice(0, 3)
                      ?.map((article) => (
                        <div
                          className="article-card d-flex align-items-center"
                          onClick={() => window.open(article?.link)}
                        >
                          <div className="img-container">
                            <img
                              src={article?.image}
                              alt=""
                              className="article-image"
                            />
                          </div>
                          <div className="content">
                            <div className="d-flex gap-2 date align-items-center">
                              <div className="date">{article?.Date}</div>
                              <div className="brown-dot"></div>
                              <div className="author-name">
                                {article?.author}
                              </div>
                            </div>
                            <div className="article-title">
                              {article?.title}
                            </div>
                            <div
                              className="tag-container d-flex flex-wrap"
                              style={{ gap: "0.75rem" }}
                            >
                              {article?.tags?.slice(0, 2).map((item) => (
                                <div className="tag-item">{item}</div>
                              ))}{" "}
                            </div>
                          </div>
                        </div>
                      ))}
                    <div className="post-card"></div>
                  </div>
                </div>
              </div>
            ) : null}

            {activeTab == "Videos" || activeTab == "All" ? (
              <div>
                <div className="Caption off-black" style={{ fontSize: "20px", marginBottom: "20px" }} ref={ref}>Videos</div>
                <div className="video-container">
                  {contents?.map((video) => (
                    <div className="video-card" key={video?.id}>
                      <div className="video-wrapper">
                        <video controls poster={cover}>
                          <source
                            src={video?.images[0]?.src}
                            type="video/mp4"
                          />
                        </video>
                        <div className="video-overlay"></div>
                      </div>
                      <div>
                        <div className="video-title">{video?.text}</div>
                        <div className="d-flex align-items-center date">
                          <div className="">{video?.date}</div>
                          <div className="brown-dot"></div>
                          <div className="duration">
                            {video?.duration || "1 min"}
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaPage;
